import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { INFO, SUCCESS, ERROR } from 'store/modules/messages';
import './Notifications.css';

const TIMEOUT = 6000;

class Notifications extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  UNSAFE_componentWillReceiveProps () {
    this.setState({ isVisible: true });

    clearTimeout(this.timer);
    this.timer = setTimeout(this.hideMessage, TIMEOUT);
  }

  componentWillUnmount () {
    clearTimeout(this.timer);
  }

  hideMessage = () => {
    this.setState({ isVisible: false });
  }

  render () {
    const { isVisible } = this.state;
    const { content, type } = this.props;

    const classNames = cn('message', {
      [`message--${type}`]: type !== null
    });

    return (
      <div
        className={classNames}
        hidden={!isVisible}
        onClick={this.hideMessage}>
        <p>{content}</p>
      </div>
    );
  }
}

Notifications.propTypes = {
  content: PropTypes.string,
  type: PropTypes.oneOf([
    INFO,
    SUCCESS,
    ERROR
  ])
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.js